import React from 'react'
import './HeaderSlide.css'

function HeaderSlide({ text}) {
  return (
    <div className="header-slide">
      <div className="header-slide-blurr">
        <h1 className="header-slide-title text-center">{text}</h1>
        <h1 className="header-slide-title text-center text-light">{text}</h1>
      </div>
    </div>
  );
}

export default HeaderSlide;